import { animate, style, transition, trigger, group, query } from '@angular/animations';

export const SHOPLIST_ANIMATIONS = [
  // animate shops entering and leaving on for example filtering
  trigger('shopAnimation', [
    transition(':enter', [
      style({
        height: '0px',
        minHeight: 0,
        opacity: 0,
        'margin-bottom': 0
      }),
      group([
        animate('200ms', style({ height: '*', minHeight: '*', 'margin-bottom': '*' })),
        animate(
          '200ms 200ms',
          style({
            opacity: 1
          })
        )
      ])
    ]),
    transition(':leave', [
      animate(
        '250ms ease-out',
        style({
          opacity: 0,
          height: 0,
          minHeight: 0,
          'margin-bottom': 0,
          transform: 'translateY(+50px)'
        })
      )
    ])
  ]),
  // switch between shop list and loading indicator
  trigger('loadingAnimation', [
    transition(':enter', [style({ opacity: 0 }), animate('500ms ease-out', style({ opacity: 1 }))]),
    transition(':leave', [animate('500ms ease-out', style({ opacity: 0 }))])
  ]),
  // animates blocker layover and loading indicator for offers
  trigger('offerAnimation', [
    transition(':enter', [
      group([
        query('.window', [
          style({ opacity: 0, transform: 'translateY(+100px) rotate(4deg)' }),
          animate('400ms 100ms ease-out', style({ opacity: 1, transform: 'none' }))
        ]),
        style({ opacity: 0 }),
        animate('200ms', style({ opacity: 1 }))
      ])
    ]),
    transition(':leave', [
      group([
        query('.window', [
          animate('500ms ease-out', style({ opacity: 0, transform: 'translateY(+100px) rotate(4deg)' }))
        ]),
        animate('200ms', style({ opacity: 0 }))
      ])
    ])
  ])
];
